<template>
    <!-- Voter Search Dropdown -->
    <BDropdown class="me-2" no-caret>
        <template #button-content>
            <input title="Find a voter" type="text" v-model="contactSearch" class="form-control" placeholder="John Doe"
                @click.stop>
        </template>
        <div class="container wider-dropdown" v-if="contactSearchResults.length">
            <h2>Search Results</h2>
            <template v-for="contact in contactSearchResults" :key="contact">
                <ContactCardComponent :contact="contact" :contactId="contact['aplos_contact_id']"
                    :currentUserRoles="currentUserRoles" :searchResult="true" />
            </template>
        </div>
    </BDropdown>
</template>

<script>
import ContactCardComponent from '@/common/components/cards/ContactCardComponent.vue';
import { mapStores } from 'pinia'
import { useDataStore } from '@/common/stores/dataStore';
import { BDropdown } from 'bootstrap-vue-next';

export default {
    name: 'ContactSearchDropdownComponent',
    components: { ContactCardComponent, BDropdown },
    props: ['currentUserRoles', 'currentUserPreferences', 'auth'],
    data() {
        return {
            contactSearch: '',
            contactSearchResults: []
        };
    },
    watch: {
        contactSearch(vs) {
            if (vs.length > 2) {
                this.searchForContact(vs)
            } else {
                this.contactSearchResults = [];
            }
        }
    },
    methods: {
        async searchForContact(searchTerm) {
            this.contactSearchResults = await this.dataStore.searchCountyContacts(searchTerm);
        },
    },
    computed: {
        ...mapStores(useDataStore)
    },
}
</script>